import { QueryKey } from '@behavior/QueryKey';
import { downloadFileCommonForPreview } from '@behavior/filesUpload/api';
import { DownloadedFileDTO } from '@behavior/filesUpload/dto/DownloadedFileDTO';
import { ChemicalProductDTO } from '@behavior/inventories/dto/ChemicalProductDTO';
import { api } from 'agent';

export function getChemicalProductQuery(chemicalId: number): Promise<ChemicalProductDTO> {
  return api
    .get(`${QueryKey.CHEMICAL_PRODUCT}/${chemicalId}`)
    .then((response: { data: ChemicalProductDTO }) => response.data);
}

export function downloadSdsFile(chemicalProductId: string): Promise<DownloadedFileDTO> {
  return downloadFileCommonForPreview(`/files/sdsFileDownload/${chemicalProductId}`);
}
